import { useState } from "react";
import platform from "platform";

export const endDateIndex = 1;

export const osPlatform = platform.os.family;

export function generateUniqueId() {
  const timestamp = new Date().getTime();
  const random = Math.random().toString(36).substring(2, 8);
  return `${timestamp}${random}`;
}

export const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const weekDays = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export const typeKeyMap = {
  "personal trainer": "personal_trainer",
  "ballroom dance": "ballroom_dance",
  "american football": "american_football",
  "english language": "english_language",
  "computer science / coding": "coding",
  "foreign languages": "foreign_languages",
};

export let numberValidation = /^[1-9]\d*(\.\d+)?$|^0(\.\d+)?$/;
export let emailValidation = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// for invitatition modal toggle

let modalState = "passive";
let listeners = [];

const setModalState = (newState) => {
  modalState = newState;
  listeners.forEach((listener) => listener(modalState));
};

export const useModalStore = () => {
  const [state, setState] = useState(modalState);

  const setGlobalState = (newState) => {
    setModalState(newState);
  };

  listeners.push(setState);

  return [state, setGlobalState];
};
